import {useEffect, useState} from "react";
import DropDown from "../../../../shared/drop-down/dropDown";
import Slider from "../../../../shared/slider/slider";
import Checkbox from "../../../../shared/checkbox/checkbox";
import tripService from "../../../../services/trip.service";
import {useDispatch, useSelector} from "react-redux";
import {
    tripDistanceFilter,
    tripVehicleFilter,
    tripGroupFilter
} from "../../../../store/slicers/tripsFilterSlicer";
import VehicleFilters from "../../../filtersComponents/vehicleFilters/vehicleFilters";
import GroupFilters from "../../../filtersComponents/groupFilters/groupFilters";

const TripsFilter = () => {
    const tripFilter = useSelector(state => state.tripsFilter);
    const dispatch = useDispatch();
    const [km, setKm] = useState(tripFilter?.distance);
    const [ratings, setRatings] = useState(2);



    const handleKm = (val) => {
        setKm(val);
    };
    const handleDistanceChange = (val) => {
        dispatch(tripDistanceFilter(val));
    };
    const handleRatings = (val) => {
        setRatings(val);
    };


    return (
        <ul className={'filter-list round-corner-8 disabled'}>
            {/*<li>*/}
            {/*    <div className="filter-text">Mileage</div>*/}
            {/*    <div className="margin-b-30">*/}
            {/*        <DropDown list={['This week', 'This month', 'This year']} selected={'This week'}/>*/}
            {/*    </div>*/}
            {/*    <div className="">*/}
            {/*        <div className="margin-b-20"><Slider onChange={handleTrip} value={20} min={0} max={50}/></div>*/}
            {/*        <div className="sf-medium">{trip}</div>*/}
            {/*    </div>*/}
            {/*</li>*/}
            <li>
                <div className="filter-title">Alerts per 100 Kms</div>
                <div className="search-box margin-b-30 round-corner-8">
                    <input type="text" placeholder={'Search'}/>
                </div>
                <div className="filter-box flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'filter-text'}>Less than 30</label>
                </div>
                <div className="filter-box flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'filter-text'}>Less than 60</label>
                </div>
                <div className="filter-box flex ">
                    <Checkbox checked={false}/>
                    <label className={'filter-text'}>Less than 100</label>
                </div>
            </li>
            <li>
                <div className="filter-title">Distance Driven</div>
                <div className="margin-b-30"><DropDown selected={'All'} list={['All', '100km', '200km']}/></div>
                <div className="">
                    <div className="margin-b-20">
                        <Slider onChange={handleKm} onStop={handleDistanceChange}
                                value={tripFilter.distance} min={0} max={2000}/></div>
                    <div className="sf-medium">{km}km</div>
                </div>
            </li>
            <li>
                <div className="filter-title margin-b-15">Trip Score</div>
                <div className="">
                    <div className="margin-b-20">
                        <Slider onChange={handleRatings} onStop={handleRatings} step={1} value={2} min={0} max={100}/>
                    </div>
                    <div className="sf-medium">{ratings}</div>
                </div>
            </li>
            <li>
                <GroupFilters filter={tripFilter} dispatcher={tripGroupFilter}/>
                {/*<div className="filter-box flex">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'filter-text'}>Group 1</label>*/}
                {/*</div>*/}
                {/*<div className="filter-box flex">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'filter-text'}>Group 2</label>*/}
                {/*</div>*/}
                {/*<div className="filter-box flex">*/}
                {/*    <Checkbox checked={false}/>*/}
                {/*    <label className={'filter-text'}>Group 3</label>*/}
                {/*</div>*/}
                {/*<div className="filter-box flex">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'filter-text'}>Group 4</label>*/}
                {/*</div>*/}
            </li>
            <li>
                <VehicleFilters filter={tripFilter} dispatcher={tripVehicleFilter}/>
                {/*<div className="filter-box flex margin-b-20">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'filter-text'}>KA 05 HJ 1890</label>*/}
                {/*</div>*/}
                {/*<div className="filter-box flex margin-b-20">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'filter-text'}>KA 06 HJ 1360</label>*/}
                {/*</div>*/}
                {/*<div className="filter-box flex margin-b-20">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'filter-text'}>KA 07 HJ 2890</label>*/}
                {/*</div>*/}
                {/*<div className="filter-box flex margin-b-20">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'filter-text'}>KA 02 HJ 7830</label>*/}
                {/*</div>*/}
                {/*<div className="filter-box flex margin-b-20">*/}
                {/*    <Checkbox checked={true}/>*/}
                {/*    <label className={'filter-text'}>KA 05 HJ 1890</label>*/}
                {/*</div>*/}
            </li>
            {/*<li>*/}
            {/*    <div className="filter-text">Current Location (State)</div>*/}
            {/*    <div className="filter-box flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'filter-text'}>Andhra Pradesh</label>*/}
            {/*    </div>*/}
            {/*    <div className="filter-box flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'filter-text'}>Assam</label>*/}
            {/*    </div>*/}
            {/*    <div className="filter-box flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'filter-text'}>Chandigharh</label>*/}
            {/*    </div>*/}
            {/*    <div className="filter-box flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'filter-text'}>Delhi</label>*/}
            {/*    </div>*/}
            {/*    <div className="filter-box flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'filter-text'}>Gujarat</label>*/}
            {/*    </div>*/}
            {/*    <div className="filter-box flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'filter-text'}>Karnataka</label>*/}
            {/*    </div>*/}
            {/*</li>*/}
        </ul>
    )
}
export default TripsFilter;
